import React, { Component } from 'react';
import Routers from './router';
import { Provider } from 'react-redux'
import store from './store'
import { I18nProvider } from './i18n';

// import SplashCursor from '@/components/ReactBits/SplashCursor'

class App extends Component {
    render() {
        return <I18nProvider>
            <Provider store={ store }>
                {/*<SplashCursor/>*/ }
                <Routers/>
            </Provider>
        </I18nProvider>
    }
}

export default App;
